/**
 * Whoever *did* something in the system: created a task, wrote a comment,
 * uploaded a file, logged time. Always a real signed-in user.
 *
 * Not who work is assigned *to* -- that is an `Assignee` (see lib/assignees.ts),
 * which is a separate record that never signs in. There is no endpoint here:
 * users only ever arrive embedded in whatever they touched.
 */
export type Member = {
  id: string;
  email: string;
  name: string | null;
  pictureUrl: string | null;
};

/** Falls back to the address, which is always present, when someone has not set
 *  a display name. */
export const memberName = (member: Member | null): string =>
  member ? (member.name ?? member.email) : 'Unknown';
